export enum TipoNotificacaoEnum {

    CAN = 'CAN'

}
